import classes from "./compass-loader.module.scss";

/**
 * Self-contained compass "seeking a bearing" loader — converted
 * directly from the provided SVG/CSS. No JS-driven animation; the
 * needle swing and halo pulse are both pure CSS keyframes, exactly as
 * given, just moved into a scoped module so they don't leak into the
 * rest of the app's global styles.
 */
export default function CompassLoader({ size = 100 }) {
  return (
    <div className={classes["compass-loader"]} style={{ width: size, height: size }}>
      <div className={classes["halo"]} />
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="92" fill="var(--compass-teal)" stroke="var(--compass-ink)" strokeWidth="10" />
        <circle cx="100" cy="88" r="66" fill="var(--compass-face)" stroke="var(--compass-ink)" strokeWidth="10" />
        <line x1="14" y1="100" x2="186" y2="100" stroke="var(--compass-ink)" strokeWidth="7" strokeLinecap="round" />
        <g className={classes["needle-group"]}>
          <line x1="100" y1="100" x2="146" y2="56" stroke="var(--compass-ink)" strokeWidth="9" strokeLinecap="round" />
          <circle cx="100" cy="100" r="9" fill="var(--compass-face)" stroke="var(--compass-ink)" strokeWidth="7" />
        </g>
      </svg>
    </div>
  );
}